import React, { PureComponent } from 'react'
import { Link } from 'react-router'
import moment from 'moment'
import i18next from 'i18next'
import classnames from 'classnames'

import DocumentLink from './DocumentLink'

import listingStyles from './styles/listing.scss'
import adminStyles from './styles/admin.scss'

const calculateTestState = target => {
  if (target.closedAt) {
    return {
      state: 'closed',
      text: i18next.t('test_state_closed'),
      timestamp: target.closedAt
    }
  }

  if (
    moment()
      .startOf('day')
      .isAfter(moment(target.deadlineAt).startOf('day'))
  ) {
    return {
      state: 'expired',
      text: i18next.t('test_state_expired'),
      timestamp: target.deadlineAt
    }
  }

  return {
    state: 'open',
    text: i18next.t('test_state_open'),
    timestamp: target.deadlineAt
  }
}

const intersperse = (list, separator) => {
  return list.length === 0
    ? []
    : list.slice(1).reduce((acc, curr) => [...acc, separator, curr], [list[0]])
}

export default class Wopi360TargetListTableRow extends PureComponent {
  handleDeleteClick = e => {
    e.preventDefault()

    this.props.onDelete(this.props.target.uuid)
  }

  render() {
    const { target, language, isDeleted, isClosed, deleteText, hideUnits } = this.props

    const testState = calculateTestState(target)

    const hasUnits = target.units.length > 0

    return (
      <tr
        className={classnames({
          [listingStyles.targetClosed]: isClosed,
          [listingStyles.targetDeleted]: isDeleted
        })}
      >
        <td>
          {!isDeleted && (
            <Link to={`/target/${target.uuid}/details`}>
              {target.givenName} {target.familyName}
            </Link>
          )}

          {isDeleted && (
            <span>
              {target.givenName} {target.familyName}
            </span>
          )}

          <small>{target.email}</small>

          <small>{target.role}</small>
        </td>
        <td>
          {target.organisation || '-'}

          {!hideUnits &&
            !isDeleted &&
            hasUnits && (
              <small className={listingStyles.unitList}>
                {intersperse(
                  target.units.map(unit => (
                    <Link key={unit.uuid} to={`/units/${unit.uuid}`}>
                      {unit.name}
                    </Link>
                  )),
                  ', '
                )}
              </small>
            )}

          {!hideUnits &&
            !isDeleted &&
            !hasUnits && (
              <Link className={adminStyles.greyDarkLink} to={`/target/${target.uuid}/edit`}>
                <small>{i18next.t('attach_target_to_units')}</small>
              </Link>
            )}
        </td>

        <td>{moment(target.createdAt).format('dd l')}</td>

        <td>{moment(target.deadlineAt).format('dd l')}</td>

        <td>
          <span
            className={classnames({
              [listingStyles.testOpen]: testState.state === 'open',
              [listingStyles.testClosed]: testState.state === 'closed',
              [listingStyles.testExpired]: testState.state === 'expired'
            })}
          >
            {testState.text}
          </span>
        </td>
        <td>
          {target.answerCount}/{target.invitationsCount}
        </td>

        <td>
          {!isDeleted &&
            target.closedAt && (
              <DocumentLink
                href={`/api/targets/${target.uuid}/profiles/${language}`}
                text={i18next.t('download_pdf')}
              />
            )}

          {isDeleted && target.closedAt && '-'}
        </td>

        {!isDeleted && (
          <td>
            <a href="#" onClick={this.handleDeleteClick}>
              {deleteText}
            </a>
          </td>
        )}

        {isDeleted && (
          <td>
            <span>{deleteText}</span>
          </td>
        )}
      </tr>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Wopi360TargetListTableRow.js